import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function ContactForm() {
  const photoRef = useScrollReveal<HTMLDivElement>(0.1, 'scale');
  const infoRef = useScrollReveal<HTMLDivElement>(0.1, 'fade-left');

  return (
    <section className="relative bg-background-50 px-6 md:px-10 lg:px-16 py-12 md:py-20">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          {/* Photo — scale in on reveal */}
          <div className="lg:col-span-5">
            <div ref={photoRef} className="relative aspect-[3/4] overflow-hidden img-hover-zoom">
              <img
                src="https://storage.readdy-site.link/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/585ae5b9-a6af-43fa-96dd-3d0fcc5623d5_compressed_Contact-Page4.webp"
                alt="Keaton Brown"
                className="w-full h-full object-cover object-top"
                style={{ imageRendering: '-webkit-optimize-contrast' }}
              />
            </div>
          </div>

          {/* Contact Info — fade-left on reveal, staggered children */}
          <div className="lg:col-span-7 flex flex-col justify-center h-full">
            <div ref={infoRef} className="stagger-children">
              <div className="mb-8 md:mb-10">
                <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-tight mb-3">
                  Get in Touch
                </h2>
                <p className="text-foreground-500 text-sm md:text-base max-w-lg leading-relaxed">
                  For performance inquiries, teaching engagements, or any questions, please reach out directly.
                </p>
              </div>

              {/* Contact details — email as a prominent CTA button */}
              <div className="space-y-8 md:space-y-10">
                <div>
                  <p className="text-xs tracking-[0.15em] uppercase text-foreground-400 font-medium mb-3">
                    Email
                  </p>
                  <a
                    href="mailto:keatonbrown98@gmail.com"
                    className="inline-flex items-center gap-3 bg-primary-500 text-background-50 px-7 py-3.5 rounded-full text-base md:text-lg font-heading whitespace-nowrap hover:bg-primary-600 transition-all duration-300 hover:scale-105 shadow-sm"
                  >
                    <i className="ri-mail-line text-lg"></i>
                    Contact Me
                  </a>
                  <p className="mt-2.5 text-foreground-400 text-sm">keatonbrown98@gmail.com</p>
                </div>

                <div>
                  <p className="text-xs tracking-[0.15em] uppercase text-foreground-400 font-medium mb-2">
                    Location
                  </p>
                  <p className="text-foreground-600 text-base md:text-lg">Houston, Texas</p>
                </div>
              </div>

              {/* Divider */}
              <div className="w-full h-[1px] bg-foreground-100 my-8 md:my-10" />

              {/* Socials */}
              <div>
                <p className="text-xs tracking-[0.15em] uppercase text-foreground-400 font-medium mb-4">
                  Connect
                </p>
                <div className="flex items-center gap-4">
                  <a
                    href="https://www.facebook.com/share/199vhZLZKK/?mibextid=wwXIfr"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-11 h-11 rounded-full border border-foreground-200 flex items-center justify-center text-foreground-500 hover:text-accent-500 hover:border-accent-500 hover:scale-110 transition-all duration-300"
                    aria-label="Facebook"
                  >
                    <i className="ri-facebook-line text-lg"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/keabrown_"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-11 h-11 rounded-full border border-foreground-200 flex items-center justify-center text-foreground-500 hover:text-accent-500 hover:border-accent-500 hover:scale-110 transition-all duration-300"
                    aria-label="Instagram"
                  >
                    <i className="ri-instagram-line text-lg"></i>
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UCkGxUgyAnQMkplDOAeaWelg"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-11 h-11 rounded-full border border-foreground-200 flex items-center justify-center text-foreground-500 hover:text-accent-500 hover:border-accent-500 hover:scale-110 transition-all duration-300"
                    aria-label="YouTube"
                  >
                    <i className="ri-youtube-line text-lg"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}